/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IAbilityMethods,
  AbilityService,
  SidebarItemService,
  ISidebarMethods,
  WhoamiService,
  IWhoamiMethods,
  UserService,
  IUserMethods,
  IOrganisationMethods,
  OrganisationService,
  BrandService,
  IBrandMethods,
  RoutesService,
  IRoutesMethods,
  DropdownService,
  IDropdownMethods,
  FooterService,
  IFooterMethods,
  AuthService,
  IAuthMethods,
} from "./components";

export type AppNavigatorAgent = IAbilityMethods &
  ISidebarMethods &
  IWhoamiMethods &
  IUserMethods &
  IBrandMethods &
  IOrganisationMethods &
  IRoutesMethods &
  IDropdownMethods &
  IAuthMethods &
  IFooterMethods;

const getPlugins = () => {
  return [
    new AbilityService(),
    new SidebarItemService(),
    new WhoamiService(),
    new UserService(),
    new BrandService(),
    new OrganisationService(),
    new RoutesService(),
    new DropdownService(),
    new FooterService(),
    new AuthService(),
  ];
};

export const getAgent = () => {
  return createAgent<AppNavigatorAgent>({
    plugins: getPlugins(),
  });
};
